module.exports = __webpack_public_path__ + "static/media/narayanaHealthLogo.a9b3d7eb.svg";